import * as React from 'react'
import Typography from '../Typography'
import CloseButton from './CloseButton'
import styles from './Notification.module.scss'

type NotificationProps = {
  actionButton?: React.ReactNode
  closable: boolean
  message: React.ReactNode
  onClose: () => void
}

const Notification: React.FunctionComponent<NotificationProps> = ({
  actionButton = undefined,
  closable,
  message,
  onClose,
}) => (
  <div className={styles.root}>
    <Typography>{message}</Typography>
    {closable && <CloseButton onClose={onClose} />}
    {actionButton && actionButton}
  </div>
)

export default Notification
